// extracted by mini-css-extract-plugin
module.exports = {"year-underlay":"YearUnderlay_year-underlay__qiUlV","year":"YearUnderlay_year__1GI9v"};